var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4556 2H1.53753C1.2408 2 1 2.24188 1 2.53859V13.5486C1 13.8453 1.2408 14.0861 1.53753 14.0861L14.4556 14.0066C14.7529 14.0066 14.9942 13.7658 14.9942 13.4691V2.53859C14.9942 2.24187 14.7529 2 14.4556 2ZM11.3244 2.72836C11.7714 2.72836 12.1318 3.0898 12.1318 3.53626C12.1318 3.98272 11.7714 4.34306 11.3244 4.34306C10.8774 4.34306 10.5176 3.98272 10.5176 3.53626C10.5176 3.0898 10.8774 2.72836 11.3244 2.72836ZM9.90498 9.00506H6.06843V5.18058H9.90498V9.00506ZM4.70384 2.72836C5.1503 2.72836 5.51173 3.0898 5.51173 3.53626C5.51173 3.98272 5.1503 4.34306 4.70384 4.34306C4.25738 4.34306 3.89649 3.98272 3.89649 3.53626C3.89649 3.0898 4.25738 2.72836 4.70384 2.72836ZM1.63568 5.18058H5.45249V8.99739H1.63568V5.18058ZM1.61978 9.6177H5.47223V13.4537H1.61978V9.6177ZM6.07557 9.63361H9.90498V13.4641H6.07557V9.63361ZM14.358 13.4641H10.5286V9.63361H14.358V13.4641ZM14.358 9.01164H10.5417V5.17124H14.358V9.01164Z",
    fill: "#4C4C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.dc625e149e35260fee32ac3d350bb6d9.svg";
export { ForwardRef as ReactComponent };